import { findUnenrolledStudent, findEnrolledStudent } from "./utils.js";
import addNewStudent from "./student.js";
import axios from "axios";

import { SHS_ADMIN_BASE_URL } from "./constants.js";

const BUY_VOUCHER_URL = `${SHS_ADMIN_BASE_URL}/voucher/buy`;

/**
 *
 * @param {Object} data
 * @param {string} data.jhsIndexNumber
 * @param {number} data.schoolId
 * @param {string} data.phoneNumber
 * @param {string} data.callbackUrl
 * @param {string} data.schoolCode
 * @returns
 */
export async function buyVoucher({
  jhsIndexNumber,
  schoolId,
  phoneNumber,
  callbackUrl,
  schoolCode,
}) {
  try {
    // Call shsadmissions to buy voucher
    const { data: buyVoucherResult } = await axios({
      url: BUY_VOUCHER_URL,
      method: "post",
      headers: { "Content-Type": "application/json" },
      data: { jhsIndexNumber, schoolId, phoneNumber, callbackUrl },
    });
    return buyVoucherResult;
  } catch (error) {
    // If it's a validation error, it means the student is not found for sepecified school
    if (error.response?.data?.name == "ValidationError") {
      // Get the student from CSSPS
      const result = await findUnenrolledStudent({
        schoolCode,
        indexNumber: jhsIndexNumber,
        schoolId,
      });
      //   If the student if not found, find student in enrolled list
      let enrolledStudent;
      if (!(result.type == "found")) {
        enrolledStudent = await findEnrolledStudent({
          schoolCode,
          schoolId,
          indexNumber: jhsIndexNumber,
        });
        if (!(enrolledStudent.type == "found")) throw error;
      }

      const { student } = result;
      const addStudentResult = await addNewStudent({
        jhsIndexNumber: jhsIndexNumber,
        admissionYear: student?.year || null,
        name: student?.name || enrolledStudent?.student?.name,
        gender: student?.gender || enrolledStudent?.student?.gender,
        programOffered: student?.programme || enrolledStudent?.student?.program,
        track: student?.dtrack || enrolledStudent?.student?.dtrack,
        residentialStatus:
          student?.residency || enrolledStudent?.student?.residency,
        lastSchoolAttended: student?.jhs_name || "",
        grade: student?.aggregate || enrolledStudent?.student?.aggregate,
        score: student?.raw_score || enrolledStudent?.student?.raw_score,
        enrolmentCode: student?.enrollment_code || "",
        schoolId: schoolId,
      });
      return await buyVoucher({
        jhsIndexNumber,
        schoolId,
        phoneNumber,
        callbackUrl,
        schoolCode,
      });
    }

    throw error;
  }
}
